import modal from '@/utils/modal.js';
import { defineAsyncComponent } from 'vue';

const PostModal = defineAsyncComponent(async () => {
  return await import(/* webpackChunkName: "stage-2" */'@/widgets/PostModal');
});

function openPopupProfileCard (commentId, initialIndex = 0) {
  const m = modal.create(PostModal, true, { provide: { commentId, initialIndex } });
  m.body.setAttribute('data-gmf', ''); // This signals that we are already handling this element (so for example elAttach wont mess with it)
  m.body.classList.add('gmf-post-modal');
}

export default openPopupProfileCard;